export default "__VITE_ASSET__CYJxFTNb__"